import WvMap from "./WvMap";
import CountyCard from "./CountyCard";
import { useState } from "react";
function MapTool() {
  const [county, setCounty] = useState("");

  return (
    <div style={{ height: "100vh" }}>
      <div className="pt-5 pb-3 mb-1 text-center bg light">
        <h3
          className="h4 mb-1 text-primary fw-bold"
          style={{ marginTop: "58px" }}
        >
          To give or see more info, click on a county.
        </h3>
      </div>
      <div className="container-fluid overflow-hidden content-container">
        <div className="row justify-content-evenly">
          <div className="col-md-8 card main-card mb-10">
            <WvMap county={county} setCounty={setCounty}></WvMap>
          </div>
          {county && <CountyCard county={county}></CountyCard>}
        </div>
      </div>
    </div>
  );
}

export default MapTool;
